var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',[_c('header',[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.title)))])]),_c('main',[_c('simple-page',{attrs:{"sections":_vm.sections}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }